// src/App.jsx
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/AuthContext.jsx';
import Sidebar from './components/Sidebar.jsx';
import NotificationBell from './components/NotificationBell.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import CaseDetail from './pages/CaseDetail.jsx';
import StaffManagement from './pages/StaffManagement.jsx';
import Reports from './pages/Reports.jsx';
import AuditLog from './pages/AuditLog.jsx';
import RoleManagement from './pages/RoleManagement.jsx';
import ResourceManagement from './pages/ResourceManagement.jsx';
import Settings from './pages/Settings.jsx';
import LiveConversations from './pages/LiveConversations.jsx';
import Calendar from './pages/Calendar.jsx';

function RequireAuth({ children }) {
  const { staff, loading } = useAuth();
  if (loading) return null;
  if (!staff) return <Navigate to="/login" replace />;
  return children;
}

function Shell({ children }) {
  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="h-14 border-b border-ink/10 bg-white flex items-center justify-end px-6 sticky top-0 z-10">
          <NotificationBell />
        </div>
        <main className="flex-1 min-w-0">{children}</main>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<RequireAuth><Shell><Dashboard /></Shell></RequireAuth>} />
          <Route path="/mine" element={<RequireAuth><Shell><Dashboard mineOnly title="My cases" /></Shell></RequireAuth>} />
          <Route path="/cases/mental-health" element={<RequireAuth><Shell><Dashboard category="mental_health" title="Mental Health Cases" /></Shell></RequireAuth>} />
          <Route path="/cases/gbv" element={<RequireAuth><Shell><Dashboard category="gbv" title="GBV Cases" /></Shell></RequireAuth>} />
          <Route path="/cases/follow-up" element={<RequireAuth><Shell><Dashboard followUp title="Follow-up" /></Shell></RequireAuth>} />
          <Route path="/cases/live" element={<RequireAuth><Shell><LiveConversations /></Shell></RequireAuth>} />
          <Route path="/appointments" element={<RequireAuth><Shell><Calendar /></Shell></RequireAuth>} />
          <Route path="/cases/:id" element={<RequireAuth><CaseDetail /></RequireAuth>} />
          <Route path="/staff" element={<RequireAuth><Shell><StaffManagement /></Shell></RequireAuth>} />
          <Route path="/roles" element={<RequireAuth><Shell><RoleManagement /></Shell></RequireAuth>} />
          <Route path="/resources" element={<RequireAuth><Shell><ResourceManagement /></Shell></RequireAuth>} />
          <Route path="/audit-log" element={<RequireAuth><Shell><AuditLog /></Shell></RequireAuth>} />
          <Route path="/reports" element={<RequireAuth><Shell><Reports /></Shell></RequireAuth>} />
          <Route path="/settings" element={<RequireAuth><Shell><Settings /></Shell></RequireAuth>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
